import { KTUtil } from './core/util';
import $ from 'jquery'
import router from '@/router'

export default {
    install(Vue) {
        Vue.prototype.$url = uri => {
            let current_url = window.location;

            if (current_url.host === '127.0.0.1' || current_url.host === 'localhost') {
                return current_url.protocol + '//'
                    + current_url.host + '/' + current_url.pathname.split('/')[1] + '/' + current_url.pathname.split('/')[2]
                    + uri
                ;
            }
        
            return current_url.protocol + '//' + current_url.host + '/' + uri;
        },

        Vue.prototype.showMsg = (form, type, msg) => {
            var alert = $('<div class="kt-alert kt-alert--outline alert alert-' + type + ' alert-dismissible" role="alert">\
                <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>\
                <span></span>\
            </div>');

            form.find('.alert').remove();
            alert.prependTo(form);
            KTUtil.animateClass(alert[0], 'fadeIn animated');
            alert.find('span').html(msg);
        },

        Vue.prototype.randomString = (length) => {
            return Math.random().toString(length * 4).substring(length)
        }

        Vue.prototype.goBack = () => {
            router.back()
        }


    }
}